import { getSurveyResponsesWatchers } from './entities/saga';
import { getResponsesVisibiltyWatchers } from './visibility/saga';

export const surveyResponsesSagas = [...getSurveyResponsesWatchers, ...getResponsesVisibiltyWatchers];
